<template>
    <div>
        <Navbar v-if="session || routeroot"/>
        <div class="J-body-app J-main-app">
             <router-view/>
        </div>
        <component-modal-questions/>
    </div>
</template>
<script>

import { EventBus } from '../../helpers/eventbus/event-bus.js'
import config from '../../config/env.example'

//Componentes
import Navbar from '../Templates/Views/Navbar'
import Footer from '../Templates/Views/footer'
import userprofile from '../Templates/Views/userprofile'



import initVue from '../../helpers/initVue'

import editnewusers from '../../models/editnewuser'


import componentmodalquestions from '../Templates/Views/modalquestions'

import {
    mapGetters,
    mapActions
} from 'vuex'

export default {
    data () { 
      return { 
        n: 20,
        valid:true, 
        dialog3:false,
        dialog4: false,
        identity: null,
        session: false,
        token: null,
        userstorage: {},
        routeroot: false,
        users: new editnewusers(),
        imageName: '',
        imageUrl: '',
        imageFile: '',
        addressempty: false,
        rules: {
                required: value => !!value || 'requerido.'
            }
      }
    },

    computed: mapGetters({
        indetityU: 'getIdentity',
        tokenU: 'getToken'
    }),

    mounted(){
        this.getidentity()
        this.getuser()
        var element = document.getElementById("body");
        this.routeroot = this.$route.path === '/'
        this.routeroot = this.$route.path !== '/'
        //console.log(this.$route.path)
    },
    components:{
        Navbar, userprofile, Footer, 'component-modal-questions':componentmodalquestions
        
    },
    methods: {
        menushow(){
                document.getElementById("sidebar").style = `
                    transform: translateX(0);
                `
        },
        menuhide(){
                    document.getElementById("sidebar").style = `
                        translateX(-100%);
                    `
        },
        getidentity(){
            this.identity = initVue.getIdentity().identity
            this.token = initVue.getIdentity().token
            this.session = initVue.isLogged(this.identity, this.token)
            //console.log(this.session)
        },

        /****************** * Guardar datos para identificar si el usuarios ha iniciado sesión ***************************************************+*/
        opendialog3(){
          this.dialog3=true
        },

        opendialog4(){
          this.dialog4 = true
          this.dialog3 = false
        },

        closedialog4(){
            this.dialog4 = false
        },


        getuser(){
            if(this.session){
                this.axios.get(`users/getuser`)
                /******************* * Login Exitoso!!!!******************************* */
                .then((res) => {
                    this.userstorage = res.data.user
                    this.imageUrl = this.userstorage.photo
                    let newuser = this.identity.statususer === 'newuser' && this.userstorage.address === ''
                    if(newuser){
                        this.opendialog3()
                    }

                })
                /******************* * Login Errado!!!!********************************/
                .catch((err) => {
                    console.log(err)
                })
            }
        },

        pickFile () {
            this.$refs.image.click()
        },
        onFilePicked (e) {
			const files = e.target.files
			if(files[0] !== undefined) {
				this.imageName = files[0].name
				if(this.imageName.lastIndexOf('.') <= 0) {
					return
                }
                
                if (!(/\.(jpg|png|gif|jpeg)$/i).test(this.imageName))
                {
                    alert('Comprueba la extensión de tus imagenes, recuerda que los formatos aceptados son .gif, .jpeg, .jpg y .png');
                    this.imageName = ''
                    this.imageUrl = this.userstorage.photo
                }else{
                    const fr = new FileReader ()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.imageUrl = fr.result
                        this.imageFile = files[0] // this is an image file that can be sent to server...
                        this.imageName = files[0].name
                        //console.log(this.imageUrl)


                    })
                }
			} else {
				this.imageName = ''
				this.imageFile = ''
				this.imageUrl = this.userstorage.photo
			}
        },

        editdatanewuser(){
            if (this.$refs.form.validate()) {
                this.snackbar = true
                this.users.imageFile = this.imageUrl
                this.axios.put(`users/editnewuser/${this.identity._id}/${this.token}`, this.users)
                .then((res) =>{
                    this.getuser()
                    EventBus.$emit('getuser')
                    this.closedialog4()
                })

                .catch((err) =>{
                    this.getuser()
                    EventBus.$emit('getuser')
                    console.log(err)

                })
            }

        }, 



    }

}

</script>
<style lang="scss">

.menu2{
        width: 40%;
        position: fixed;
        z-index: 100;
        cursor: pointer;
        color:black;
        top:0;
        left:0;
        transition: 0.5s;
        -webkit-transition: all .3s ease-in-out;
        -moz-transition: all .3s ease-in-out;
        -o-transition: all .3s ease-in-out;
        -ms-transition: all .3s ease-in-out;
        transition: all .3s ease-in-out;
        @media screen and (min-width: 300px) {
            width: 32%;
        }
        @media screen and (min-width: 400px) {
            width: 25%;
        }
        @media screen and (min-width: 500px) {
            width: 20%;
        }
        @media screen and (min-width: 600px) {
            width: 20%;
        }
        @media screen and (min-width: 750px) {
            width: 20%;
        }
        @media screen and (min-width: 850px) {
            width: 10%;
        }
        @media screen and (min-width: 1000px) {
            width: 10%;
        }
        @media screen and (min-width: 1100px) {
            width: 10%;
        }
        @media screen and (min-width: 1300px) {
            width: 7%;
        }
    }
  .sidebar-toggle {
    margin-left: -240px;
    }
    .sidebarindex {
    height: 100%;
    width: 100%;
    z-index: 200;
    top: 0;
    left: 0;
    overflow: auto;
    background:white;
    padding-top: 10px;
    transition: 0.5s;
    opacity: 0.9;
    -webkit-transition: all .3s ease-in-out;
    -moz-transition: all .3s ease-in-out;
    -o-transition: all .3s ease-in-out;
    -ms-transition: all .3s ease-in-out;
    transition: all .3s ease-in-out;
    z-index: 100;
    transform: translateX(-100%);
        @media screen and (min-width: 300px) {
            width: 75%;
        }
        @media screen and (min-width: 400px) {
            width: 60%;
        }
        @media screen and (min-width: 500px) {
            width: 40%;
        }
        @media screen and (min-width: 600px) {
            width: 40%;
        }
        @media screen and (min-width: 750px) {
            width: 30%;
        }
        @media screen and (min-width: 850px) {
            width: 25%;
        }
        @media screen and (min-width: 1000px) {
            width: 25%;
        }
        @media screen and (min-width: 1100px) {
            width: 20%;
        }
        @media screen and (min-width: 1300px) {
            width: 15%;
        }
        & a {
            padding: 6px 6px 6px 6px;
            text-decoration: none;
            font-size: 1.2em;
            color: black;
            display: block;
            margin: 10px 0;
            transition: all 0.5s;
            &:hover {
                background: rgb(67, 67, 67);
                border-radius: 20px;
                text-align: center;
            }
        }
    #leftside-navigation {
    ul, ul ul {
      margin: -2px 0 0;
      padding: 0;
    }
    ul {
      li {
        list-style-type: none;
        border-bottom: 1px solid rgba(255,255,255,.05);
        &.active {
          & > a {
            color:black;
          }
          ul {
            display: block;
          }
        }
        a {
          color:black;
          text-decoration: none;
          display: block;
          padding: 18px 0 18px 25px;
          font-size: 12px;
          outline: 0;
          -webkit-transition: all 200ms ease-in;
          -moz-transition: all 200ms ease-in;
          -o-transition: all 200ms ease-in;
          -ms-transition: all 200ms ease-in;
          transition: all 200ms ease-in;
          &:hover {
            color:black;
          }
          span {
            display: inline-block;
          }
          i {
            width: 20px;
            .fa-angle-left, .fa-angle-right {
              padding-top: 3px;
            }
          }
        }
      }
    }
    ul ul {
      display: none;
      li {
        background: #23313f;
        margin-bottom: 0;
        margin-left: 0;
        margin-right: 0;
        border-bottom: none;
        a {
          font-size: 12px;
          padding-top: 13px;
          padding-bottom: 13px;
          color: black;
        }
      }
    }
  }
}





</style>


